import React from "react";
import { api } from "../../lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const absolute = url => url?.startsWith("http") ? url : `${BACKEND}${url}`;
const families = { serif: "CarouselPlayfair", sans: "CarouselMontserrat", italic: "CarouselLora", script: "CarouselDancing", hand: "CarouselCaveat" };
export const CarouselFonts = () => <style>{Object.entries(families).map(([key, name]) =>
  `@font-face{font-family:${name};src:url('${BACKEND}/api/marketing/carousel-fonts/${key}') format('truetype');font-weight:100 900;font-style:normal;font-display:block;}`
).join('\n')}</style>;

export const CarouselPreview = ({ id, slide, format, total, globals, onSelect, onScene }) => {
  const [scene, setScene] = React.useState(null);
  const [state, setState] = React.useState("loading");
  const [error, setError] = React.useState("");
  const callback = React.useRef(onScene);
  callback.current = onScene;
  React.useEffect(() => {
    const controller = new AbortController();
    let active = true;
    setState("loading"); setError("");
    const timer = setTimeout(async () => {
      try {
        const result = await api.post('/admin/marketing/carousels/preview', {
          slide, format, total, global_typography: globals || {},
        }, { signal: controller.signal });
        if (!active) return;
        callback.current(result.data);
        if (result.data.valid) { setScene(result.data); setState("ready"); }
        else setState("overflow");
      } catch (e) {
        if (!active) return;
        setError("Aperçu indisponible. Les modifications restent conservées."); setState("error");
      }
    }, 60);
    return () => { active = false; clearTimeout(timer); controller.abort(); };
  }, [slide, format, total, globals]);

  return <div className="carousel-preview" data-testid={`${id}-preview`}>
    <div className="preview-status" data-testid={`${id}-preview-status`} aria-live="polite">
      {state === 'loading' ? 'Composition…' : state === 'overflow' ? 'Espace insuffisant · dernier aperçu valide' : state === 'error' ? error : 'Aperçu en direct'}
    </div>
    {scene ? <svg viewBox={`0 0 ${scene.width} ${scene.height}`} role="img" aria-label={`Aperçu page ${slide.index + 1}`}
      data-testid={`${id}-preview-canvas`} className="carousel-canvas" style={{ aspectRatio: `${scene.width}/${scene.height}` }}>
      <rect width={scene.width} height={scene.height} fill={scene.background}/>
      {scene.source_image_url && <image data-testid={`${id}-preview-photo`} href={absolute(scene.source_image_url)} {...scene.photo} opacity={1} preserveAspectRatio="xMidYMid meet"/>}
      {scene.blocks.map(block => <g key={block.role} data-testid={`${id}-preview-${block.role}`} role="button" tabIndex={0}
        aria-label={`Sélectionner ${block.role}`} onClick={() => onSelect(block.role)} onKeyDown={e => { if (e.key === 'Enter') onSelect(block.role); }}
        style={{ cursor: 'pointer' }}>
        <rect x={block.x} y={block.y} width={block.width} height={Math.max(20, block.height)} fill="transparent"/>
        <g opacity={block.style.opacity / 100} fontFamily={families[block.style.font]} fontSize={block.style.size}
          fontWeight={block.style.weight} fill={block.style.color} letterSpacing={block.style.letter_spacing} style={{ fontKerning: 'none' }}>
          {block.rows.map((row, i) => <React.Fragment key={i}>
            {row.bullet && <text x={row.x - block.indent} y={row.y}>•</text>}
            <text x={row.x} y={row.y} xmlSpace="preserve">{row.text}</text>
          </React.Fragment>)}
        </g>
      </g>)}
    </svg> : slide.rendered_url ? <img data-testid={`${id}-previous-preview`} src={absolute(slide.rendered_url)} alt="Dernier rendu enregistré"/>
      : <div className="preview-empty" data-testid={`${id}-preview-empty`}>{state === 'overflow' ? 'Ajustez la mise en page pour afficher cette composition.' : 'Préparation de la composition…'}</div>}
  </div>;
};